"use client";

import { useUser } from "@clerk/tanstack-react-start";
import { useEffect } from "react";

import { getLatestUpdate } from "#/content/updates";
import { persistUpdatesSeen } from "#/lib/persistUpdatesSeen";

export function MarkUpdatesSeenOnVisit() {
  const { isSignedIn, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    const latestUpdateId = getLatestUpdate()?.id;
    if (!latestUpdateId) return;
    void persistUpdatesSeen({ updateId: latestUpdateId, isSignedIn: Boolean(isSignedIn) });
  }, [isLoaded, isSignedIn]);

  return null;
}
